import { HttpClient } from '@wix/sdk-types';
import {
  AddDeliveryRegionOptions,
  AddDeliveryRegionResponse,
  AddDeliveryRegionResponseNonNullableFields,
  BulkCreateLocalDeliveryOptionResponse,
  BulkCreateLocalDeliveryOptionResponseNonNullableFields,
  BulkUpdateLocalDeliveryOptionResponse,
  BulkUpdateLocalDeliveryOptionResponseNonNullableFields,
  DeleteLocalDeliveryOptionOptions,
  GetLocalDeliveryOptionOptions,
  ListLocalDeliveryOptionsResponse,
  ListLocalDeliveryOptionsResponseNonNullableFields,
  LocalDeliveryOption,
  LocalDeliveryOptionNonNullableFields,
  LocalDeliveryOptionsQueryBuilder,
  RemoveDeliveryRegionOptions,
  RemoveDeliveryRegionResponse,
  RemoveDeliveryRegionResponseNonNullableFields,
  UpdateLocalDeliveryOption,
  addDeliveryRegion as universalAddDeliveryRegion,
  bulkCreateLocalDeliveryOption as universalBulkCreateLocalDeliveryOption,
  bulkDeleteLocalDeliveryOption as universalBulkDeleteLocalDeliveryOption,
  bulkUpdateLocalDeliveryOption as universalBulkUpdateLocalDeliveryOption,
  createLocalDeliveryOption as universalCreateLocalDeliveryOption,
  deleteLocalDeliveryOption as universalDeleteLocalDeliveryOption,
  getLocalDeliveryOption as universalGetLocalDeliveryOption,
  listLocalDeliveryOptions as universalListLocalDeliveryOptions,
  queryLocalDeliveryOptions as universalQueryLocalDeliveryOptions,
  removeDeliveryRegion as universalRemoveDeliveryRegion,
  updateLocalDeliveryOption as universalUpdateLocalDeliveryOption,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function createLocalDeliveryOption(
  httpClient: HttpClient
): CreateLocalDeliveryOptionSignature {
  return (localDeliveryOption: LocalDeliveryOption) =>
    universalCreateLocalDeliveryOption(
      localDeliveryOption,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateLocalDeliveryOptionSignature {
  /** */
  (localDeliveryOption: LocalDeliveryOption): Promise<
    LocalDeliveryOption & LocalDeliveryOptionNonNullableFields
  >;
}

export function getLocalDeliveryOption(
  httpClient: HttpClient
): GetLocalDeliveryOptionSignature {
  return (
    localDeliveryOptionId: string,
    options?: GetLocalDeliveryOptionOptions
  ) =>
    universalGetLocalDeliveryOption(
      localDeliveryOptionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptionId: string,
    options?: GetLocalDeliveryOptionOptions | undefined
  ): Promise<LocalDeliveryOption & LocalDeliveryOptionNonNullableFields>;
}

export function listLocalDeliveryOptions(
  httpClient: HttpClient
): ListLocalDeliveryOptionsSignature {
  return (externalId: string) =>
    universalListLocalDeliveryOptions(
      externalId,
      // @ts-ignore
      { httpClient }
    );
}

interface ListLocalDeliveryOptionsSignature {
  /** @deprecated method is deprecated due to the fact that external_id is deprecated */
  (externalId: string): Promise<
    ListLocalDeliveryOptionsResponse &
      ListLocalDeliveryOptionsResponseNonNullableFields
  >;
}

export function queryLocalDeliveryOptions(
  httpClient: HttpClient
): QueryLocalDeliveryOptionsSignature {
  return () =>
    universalQueryLocalDeliveryOptions(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryLocalDeliveryOptionsSignature {
  /**
   * Retrieves a list of local delivery options, given the provided paging, filtering, and sorting.
   *
   * For field support for filters and sorting, see [Local Delivery: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/payments/tax/tax-regions/supported-filters-and-sorting).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  (): LocalDeliveryOptionsQueryBuilder;
}

export function updateLocalDeliveryOption(
  httpClient: HttpClient
): UpdateLocalDeliveryOptionSignature {
  return (_id: string | null, localDeliveryOption: UpdateLocalDeliveryOption) =>
    universalUpdateLocalDeliveryOption(
      _id,
      localDeliveryOption,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateLocalDeliveryOptionSignature {
  /** @param - LocalDeliveryOptionId - unique identifier of local delivery option */
  (_id: string | null, localDeliveryOption: UpdateLocalDeliveryOption): Promise<
    LocalDeliveryOption & LocalDeliveryOptionNonNullableFields
  >;
}

export function deleteLocalDeliveryOption(
  httpClient: HttpClient
): DeleteLocalDeliveryOptionSignature {
  return (
    localDeliveryOptionId: string,
    options?: DeleteLocalDeliveryOptionOptions
  ) =>
    universalDeleteLocalDeliveryOption(
      localDeliveryOptionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface DeleteLocalDeliveryOptionSignature {
  /** */
  (
    localDeliveryOptionId: string,
    options?: DeleteLocalDeliveryOptionOptions | undefined
  ): Promise<void>;
}

export function bulkCreateLocalDeliveryOption(
  httpClient: HttpClient
): BulkCreateLocalDeliveryOptionSignature {
  return (localDeliveryOptions: LocalDeliveryOption[]) =>
    universalBulkCreateLocalDeliveryOption(
      localDeliveryOptions,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkCreateLocalDeliveryOptionSignature {
  /** */
  (localDeliveryOptions: LocalDeliveryOption[]): Promise<
    BulkCreateLocalDeliveryOptionResponse &
      BulkCreateLocalDeliveryOptionResponseNonNullableFields
  >;
}

export function bulkUpdateLocalDeliveryOption(
  httpClient: HttpClient
): BulkUpdateLocalDeliveryOptionSignature {
  return (localDeliveryOptions: LocalDeliveryOption[]) =>
    universalBulkUpdateLocalDeliveryOption(
      localDeliveryOptions,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateLocalDeliveryOptionSignature {
  /** */
  (localDeliveryOptions: LocalDeliveryOption[]): Promise<
    BulkUpdateLocalDeliveryOptionResponse &
      BulkUpdateLocalDeliveryOptionResponseNonNullableFields
  >;
}

export function bulkDeleteLocalDeliveryOption(
  httpClient: HttpClient
): BulkDeleteLocalDeliveryOptionSignature {
  return (ids: string[]) =>
    universalBulkDeleteLocalDeliveryOption(
      ids,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkDeleteLocalDeliveryOptionSignature {
  /** */
  (ids: string[]): Promise<void>;
}

export function addDeliveryRegion(
  httpClient: HttpClient
): AddDeliveryRegionSignature {
  return (deliveryRegionId: string, options?: AddDeliveryRegionOptions) =>
    universalAddDeliveryRegion(
      deliveryRegionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface AddDeliveryRegionSignature {
  /** */
  (
    deliveryRegionId: string,
    options?: AddDeliveryRegionOptions | undefined
  ): Promise<
    AddDeliveryRegionResponse & AddDeliveryRegionResponseNonNullableFields
  >;
}

export function removeDeliveryRegion(
  httpClient: HttpClient
): RemoveDeliveryRegionSignature {
  return (deliveryRegionId: string, options?: RemoveDeliveryRegionOptions) =>
    universalRemoveDeliveryRegion(
      deliveryRegionId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface RemoveDeliveryRegionSignature {
  /** */
  (
    deliveryRegionId: string,
    options?: RemoveDeliveryRegionOptions | undefined
  ): Promise<
    RemoveDeliveryRegionResponse & RemoveDeliveryRegionResponseNonNullableFields
  >;
}

export {
  ActionEvent,
  AddDeliveryRegionOptions,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  AddDeliveryRegionResponseNonNullableFields,
  AddressLocation,
  BulkCreateLocalDeliveryOptionRequest,
  BulkCreateLocalDeliveryOptionResponse,
  BulkCreateLocalDeliveryOptionResponseNonNullableFields,
  BulkDeleteLocalDeliveryOptionRequest,
  BulkDeleteLocalDeliveryOptionResponse,
  BulkUpdateLocalDeliveryOptionRequest,
  BulkUpdateLocalDeliveryOptionResponse,
  BulkUpdateLocalDeliveryOptionResponseNonNullableFields,
  Condition,
  ConditionType,
  ConditionalRates,
  CreateLocalDeliveryOptionRequest,
  CreateLocalDeliveryOptionResponse,
  CreateLocalDeliveryOptionResponseNonNullableFields,
  CursorPaging,
  CursorPagingMetadata,
  Cursors,
  CustomAreaConfig,
  DayOfWeek,
  DaySlot,
  Days,
  DeleteLocalDeliveryOptionOptions,
  DeleteLocalDeliveryOptionRequest,
  DeleteLocalDeliveryOptionResponse,
  Destination,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetLocalDeliveryOptionOptions,
  GetLocalDeliveryOptionRequest,
  GetLocalDeliveryOptionResponse,
  GetLocalDeliveryOptionResponseNonNullableFields,
  IdentificationData,
  IdentificationDataIdOneOf,
  LengthUnit,
  ListLocalDeliveryOptionsRequest,
  ListLocalDeliveryOptionsResponse,
  ListLocalDeliveryOptionsResponseNonNullableFields,
  LocalDeliveryAddress,
  LocalDeliveryOption,
  LocalDeliveryOptionConfigOneOf,
  LocalDeliveryOptionError,
  LocalDeliveryOptionNonNullableFields,
  LocalDeliveryOptionsQueryBuilder,
  LocalDeliveryOptionsQueryResult,
  LogicalOperator,
  MessageEnvelope,
  Paging,
  QueryLocalDeliveryOptionsRequest,
  QueryLocalDeliveryOptionsResponse,
  QueryLocalDeliveryOptionsResponseNonNullableFields,
  QueryV2,
  QueryV2PagingMethodOneOf,
  RadiusConfig,
  RemoveDeliveryRegionOptions,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  RemoveDeliveryRegionResponseNonNullableFields,
  RestoreInfo,
  ScheduledDelivery,
  SortOrder,
  Sorting,
  TimeOfDay,
  TimePoint,
  TimeSlot,
  TimeWindow,
  UpdateLocalDeliveryOption,
  UpdateLocalDeliveryOptionRequest,
  UpdateLocalDeliveryOptionResponse,
  UpdateLocalDeliveryOptionResponseNonNullableFields,
  WebhookIdentityType,
  ZipCodeConfig,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';
